import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import { useLocation, useNavigate } from "react-router-dom";
import { setupParams } from 'app/services/setupWebview';
import Swal from 'sweetalert2';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { requestApi } from 'app/utils/RestApi';
import { AGENT, OTP } from 'app/utils/constants/endPoint';
import { isMobile } from 'react-device-detect';
import { useWindowPaste } from 'app/hooks/useWindowPaste';
import OTPCountdown from 'app/components/OTPCountdown';
import { removeOtpSession } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { ERR_MESSAGE_500 } from 'app/utils/constants/validation';
import { ERROR_SERVER_DEFAULT } from 'app/utils/appHelpers';

const WebViewOtpVerification = () => {
	const navigate = useNavigate();
	const location = useLocation();

	let isTncApproval = false;

	if (location?.state?.isTncApproval) {
		isTncApproval = !isTncApproval
	}

	const pasteValue = useWindowPaste();

	const [params, setParams] = React.useState(null);
	const [emailhide, setEmailhide] = React.useState(null);

	const navigateBack = () => {
		navigate(-1)
	}

	React.useEffect(() => {
		if (!params) {
			if (!isTncApproval) {
				const parameter = localStorage.getItem('params')
				setupParams(parameter, successCallback, false, navigateBack)
			} else {
				const paramsTmp = JSON.parse(localStorage.getItem('params'))
				setParams(paramsTmp)
			}
		}
	}, [params, setupParams, navigateBack]);

	const successCallback = (data) => {
		const newEmail = (data.email).replace(/^.{6}/, 'xxxxxx')
		setEmailhide(newEmail)
		setParams(data)
	}

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// }
		otpInputRefs[0].current.focus();
	}, []);

	const handlePaste = (value) => {
		if (value.length === 6 && (new RegExp(/^\d+$/).test(value))) {
			const otpValues = value.split('');
			setOtp(otpValues);
			otpInputRefs[otpValues.length - 1].current.focus();
		}
	}

	React.useEffect(() => {
		handlePaste(pasteValue);
	}, [pasteValue])


	const TOTAL_INPUTS = 6;

	const [otp, setOtp] = React.useState(Array(TOTAL_INPUTS).fill(''));
	const otpInputRefs = Array(TOTAL_INPUTS).fill(0).map(() => React.createRef());
	const handleOtpChange = (otpValue, index) => {
		const otpValues = [...otp];
		otpValues[index] = otpValue;
		setOtp(otpValues);

		if (otpValue.length === 1 && index !== TOTAL_INPUTS - 1) {
			otpInputRefs[index + 1].current.focus();
		}
	};

	const handleKeyDown = (event, index) => {
		if (event.keyCode === 8 && !otp[index]) {
			otpInputRefs[index - 1].current.focus();
		}
	};

	const navigateNext = () => {
		let otpLength = otp.join('');
		if (otpLength.length === 6) {
			submitData()
		} else {
			Swal.fire({
				icon: 'warning',
				text: 'Mohon masukan OTP yang valid',
				showConfirmButton: false
			})
		}
	};

	const resetOtp = () => {
		setOtp(Array(TOTAL_INPUTS).fill(''))
	}

	const submitData = async () => {
		await Swal.fire({
			title: 'Mohon Tunggu..',
			timerProgressBar: true,
			didOpen: () => {
				Swal.showLoading()
				requestApi(OTP.VERIFY_OTP_AGENT, {
					data: {
						username: params.kode,
						otp: otp.join(''),
						actionType: isTncApproval ? "WEBVIEW_TNC" : "WEBVIEW_REGIS"
					}
				}).then(({ data }) => {
					if (!params.kode) {
						Swal.close();
						Swal.fire({
							icon: 'warning',
							text: 'Missing parameter agent!',
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
					}

					if (data?.status === 'success') {
						removeOtpSession()

						Swal.close();
						if (!isTncApproval) {
							requestApi(AGENT.CREATE, {
								data: {
									name: params.nama,
									agentCode: params.kode,
									email: params.email,
									phoneNumber: params.hp,
									office: params.office,
								}
							}).then((res) => {
								const resInsertAgent = res?.data

								Swal.close();
								if (resInsertAgent?.status === 'success') {
									navigate('/webViewRegistrasiSukses');
								} else {
									Swal.fire({
										icon: 'warning',
										text: resInsertAgent?.message || ERROR_SERVER_DEFAULT,
										allowOutsideClick: false,
										confirmButtonColor: 'red'
									})
								}
							}).catch(err => {
								Swal.close();
								let message = err?.message ?? ERR_MESSAGE_500
								setTimeout(() => {
									Swal.fire({
										icon: 'warning',
										text: message,
										allowOutsideClick: false,
										confirmButtonColor: 'red'
									})
								}, 1000);
							})
						} else {
							requestApi(AGENT.AGREE_TNC, {
								params: {
									email: params.email
								}
							}).then(({ data }) => {
								if (data?.status === 'success') {
									navigateBack()
								}
							}).catch(err => {
								Swal.close();
								console.log(err)
								let message = err?.message ?? ERR_MESSAGE_500

								Swal.fire({
									icon: 'warning',
									text: message,
									allowOutsideClick: false,
									showConfirmButton: false
								})
							})
						}
					} else {
						Swal.close();
						setTimeout(() => {
							Swal.fire({
								icon: 'warning',
								text: data?.message || ERROR_SERVER_DEFAULT,
								allowOutsideClick: false,
								confirmButtonColor: 'red'
							})
						}, 1000);
					}
				}).catch(err => {
					Swal.close();
					setTimeout(() => {
						Swal.fire({
							icon: 'warning',
							text: err?.message ?? "Gagal verify otp",
							allowOutsideClick: false,
							confirmButtonColor: 'red'
						})
					}, 1000);
				})
			},
			showCloseButton: false,
			showConfirmButton: false,
			allowOutsideClick: false
		})
	}

	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Registrasi"}
				backOnClick={navigateBack}
			/>

			{/* 🔥 CONTENT */}
			<ContentWrapper isMobile>

				{/* 🔥 typography */}
				<Typography sx={{ mt: 2 }} fontSize={22} fontWeight={600} textAlign={"center"} color={"black"}>Verifikasi OTP</Typography>
				{params &&
					<Typography fontSize={16} fontWeight={500} textAlign={"center"} color={'#979797'}>OTP telah dikirimkan ke Email Anda {emailhide}</Typography>
				}

				{/* 🔥 input with icon left/right */}
				<Div sx={{ mt: 4 }}>
					{/* 🔥 input otp 	*/}
					<Div sx={{ mb: 2, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>

						{otpInputRefs && Array(TOTAL_INPUTS).fill(0).map((_, index) => (
							<input
								autoComplete="off"
								style={{
									width: '40px',
									height: '40px',
									maxHeight: '40px',
									// adjust text alignment and font size as needed
									textAlign: 'center',
									fontSize: '20px',
									margin: 6,
									borderRadius: 6,
									borderColor: "#eee"
								}}
								key={index}
								type="tel"
								name={`otp_${index}`}
								onChange={(e) => {
									if (e.nativeEvent.inputType !== "insertFromPaste") {
										handleOtpChange(e.target.value, index);
									}
								}}
								onKeyDown={(e) => handleKeyDown(e, index)}
								maxLength="1"
								ref={otpInputRefs[index]}
								value={otp[index]}
							/>
						))}
					</Div>
				</Div>
				{
					params !== null &&
					<OTPCountdown isMicrosite={false} actionType={isTncApproval ? "WEBVIEW_TNC" : "WEBVIEW_REGIS"} params={params} onRestart={() => resetOtp()} />
				}

			</ContentWrapper>

			{/* 🔥 FOOTER */}
			<MobileFooter>
				<ButtonStyled
					btnText={"Kirim"}
					preset={"primary"}
					onClick={navigateNext}
					disabled={otp.some(s => !s)}
				/>

			</MobileFooter>


		</Div>

	);
};

export default WebViewOtpVerification;